export enum DataType {
  MediaType = 'media',
  RecyclingCenter = 'recycling_centers',
  Truck = 'trucks',
  Mission = 'missions'
}
